<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleCloseOuter"
    class="large-dialog"
  >
    <div class="flex h-32px leading-32px config-tab mb-10px pl-20px">
      <div
        class="w-150px cursor-pointer text-center text-[#409eff] vis-tab"
        :class="{ 'tab-select': activeConfig === 0 }"
        @click="activeConfig = 0"
      >
        可视化配置
      </div>
      <div
        class="w-150px cursor-pointer bg-white text-center text-[#409eff] cockpit-tab"
        :class="{ 'tab-select': activeConfig === 1 }"
        @click="changeCockpitConfig"
      >
        驾驶舱配置
      </div>
    </div>
    <el-form :model="formData" label-width="160px" ref="formRef" :rules="formRules" class="px-10px">
      <el-row :gutter="20" v-if="activeConfig === 0">
        <el-col :span="12">
          <el-form-item label="功能板块" prop="name">
            <el-input
              v-model="formData.name"
              controls-position="right"
              placeholder="请输入功能板块名称"
              :disabled="operateType === 'read'"
            ></el-input>
          </el-form-item>
          <el-form-item label="关联场景">
            <el-select
              v-model="formData.sceneId"
              :disabled="operateType === 'read'"
              placeholder="关联场景"
              clearable
              filterable
            >
              <el-option
                v-for="item in sceneOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务功能" prop="businessFunction">
            <tree-transfer
              :title="['未选择', '已选择']"
              :from_data="businessFunctionList"
              :to_data="formData.businessFunction"
              filter
              filter-placeholder="请输入"
            ></tree-transfer>
          </el-form-item>
          <el-form-item label="标签配置">
            <el-button
              type="primary"
              size="small"
              @click="labelVisible = true"
              :disabled="operateType === 'read'"
              >添加</el-button
            >
            <span class="ml-20px">注：添加后此模块可选择标签，勾选是默认展示标签</span>
            <ul class="max-h-290px overflow-auto label-ui">
              <li
                v-for="(item, index) in showLabel"
                :key="index"
                class="relative flex items-center"
              >
                <el-checkbox
                  v-model="item.isChecked"
                  class="!mr-10px"
                  :disabled="item.disabled"
                ></el-checkbox>
                <div class="w-200px truncate">{{ item.label }}</div>
                <i
                  class="el-icon-close cursor-pointer ml-10px absolute right-20px"
                  @click="deleteLabel(index)"
                  v-if="item.canDelete"
                ></i>
              </li>
            </ul>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="位置" prop="functionLocationType">
            <el-select
              clearable
              v-model="formData.functionLocationType"
              filterable
              placeholder="位置"
              :disabled="operateType === 'read'"
            >
              <el-option
                v-for="item in positionList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="基础功能" prop="basicFunction" class="mt-80px">
            <tree-transfer
              :title="['未选择', '已选择']"
              :from_data="basicFunctionList"
              :to_data="formData.basicFunction"
              filter
              filter-placeholder="请输入"
            ></tree-transfer>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-else>
        <el-col :span="12">
          <el-form-item label="关联驾驶舱">
            <el-select
              v-model="formData.cockpitId"
              :disabled="operateType === 'read'"
              placeholder="关联驾驶舱"
              clearable
              filterable
            >
              <el-option
                v-for="item in cockpitOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示标签">
            <el-button
              type="primary"
              size="small"
              @click="labelVisible = true"
              :disabled="operateType === 'read'"
              >添加</el-button
            >
            <span class="ml-20px">注：添加后此模块可选择标签，勾选是默认展示标签</span>
            <ul class="max-h-290px overflow-auto label-ui">
              <li
                v-for="(item, index) in showCockpitLabels"
                :key="index"
                class="relative flex items-center"
              >
                <el-checkbox
                  v-model="item.isChecked"
                  class="!mr-10px"
                  :disabled="item.disabled"
                ></el-checkbox>
                <div class="w-200px truncate">{{ item.label }}</div>
                <i
                  class="el-icon-close cursor-pointer ml-10px absolute right-20px"
                  @click="deleteCockpitLabel(index)"
                  v-if="item.canDelete"
                ></i>
              </li>
            </ul>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联场景">
            <el-select
              v-model="formData.cockpitSceneId"
              :disabled="operateType === 'read'"
              placeholder="关联场景"
              clearable
              filterable
            >
              <el-option
                v-for="item in sceneOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="text-center" v-if="operateType !== 'read'">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleCloseOuter">取消</el-button>
    </div>
    <el-dialog
      title="添加"
      :visible.sync="labelVisible"
      :close-on-click-modal="false"
      class="small-dialog"
      append-to-body
      custom-class="label-dialog"
      @open="handleOpenInner"
    >
      <div class="flex">
        <div class="mr-10px w-150px text-right flex-shrink-0">标签配置</div>
        <el-transfer
          v-if="activeConfig === 0"
          :titles="['未选择', '已选择']"
          v-model="chooseLabelList"
          filterable
          filter-placeholder="请输入"
          :data="LabelList"
        ></el-transfer>
        <el-transfer
          v-else
          :titles="['未选择', '已选择']"
          v-model="chooseCockpitLabelList"
          filterable
          filter-placeholder="请输入"
          :data="selectLabelList"
        ></el-transfer>
      </div>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveLabel">保存</el-button>
        <el-button size="small" @click="labelVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import treeTransfer from 'el-tree-transfer'
import { SectionApi, FunctionInfoApi, LableApi } from '@wiz-api/cloud-render-management'

const sectionApi = new SectionApi()
const functionApi = new FunctionInfoApi()
const labelApi = new LableApi()
export default {
  components: {
    treeTransfer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    positionList: {
      type: Array,
      default: () => {
        return []
      },
    },
    sceneOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
    cockpitOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
    operateProps: {
      type: Object,
      default: () => {},
    },
    operateType: {
      type: String,
      default: 'create',
    },
    schemeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showCockpitLabels: [],
      activeConfig: 0,
      formData: {
        sceneId: null,
        name: '',
        functionLocationType: '',
        cockpitId: null,
        cockpitSceneId: null,
        cockpitLableIds: [],
        basicFunction: [],
        businessFunction: [],
      },
      saveLoading: false,
      formRules: {
        name: { required: true, message: '请输入功能板块名称', trigger: 'blur' },
        functionLocationType: { required: true, message: '请选择板块位置', trigger: 'blur' },
      },
      labelVisible: false,
      allLabel: [],
      showLabel: [],
      LabelList: [],
      chooseLabelList: [],
      chooseCockpitLabelList: [],
      basicFunctionList: [],
      businessFunctionList: [],
      computedNum: 0,
    }
  },
  computed: {
    title() {
      switch (this.operateType) {
        case 'create':
          return '新增板块'
        case 'read':
          return '板块详情'
        default:
          return '编辑板块'
      }
    },
    functionAll() {
      return JSON.parse(
        JSON.stringify(_.concat(this.formData.basicFunction, this.formData.businessFunction))
      )
    },
  },
  watch: {
    showLabel: {
      deep: true,
      immediate: true,
      handler(val) {
        this.LabelList = _.filter(this.allLabel, (item) => {
          let flag = true
          _.forEach(val, (i) => {
            if (i.key === item.key) {
              flag = false
            }
          })
          return flag
        })
      },
    },
    showCockpitLabels: {
      deep: true,
      immediate: true,
      handler(val) {
        this.selectLabelList = _.filter(this.showLabel, (item) => {
          let flag = true
          _.forEach(val, (i) => {
            if (i.key === item.key) {
              flag = false
            }
          })
          return flag
        })
      },
    },
    functionAll(newVal, oldVal) {
      this.computedNum++
      this.changeShowLabel(newVal, oldVal)
    },
  },
  async created() {
    // 获取所有标签列表
    await this.getLabelList()
    // 获取功能树形列表
    await this.getSubTreeList()
    if (!_.isEmpty(this.operateProps)) {
      // 查看编辑回调数据
      this.formData.name = this.operateProps.name
      this.formData.sceneId = this.operateProps.sceneId
      this.formData.cockpitId = this.operateProps.cockpitId
      this.formData.cockpitSceneId = this.operateProps.cockpitSceneId
      this.formData.functionLocationType = this.operateProps.functionLocationType
      const basicFunctionArr = this.arrToTree(
        this.operateProps.extraDto.basicFunctionInfoDtos,
        null
      )
      const businessFunctionArr = this.arrToTree(
        this.operateProps.extraDto.businessFunctionInfoDtos,
        null
      )
      const basicFunctionLableIds = Array.from(
        new Set(
          _.map(this.operateProps.extraDto.basicFunctionInfoDtos, (item) => {
            return _.split(item.extraProperties.lableIds, ',')
          }).flat()
        )
      )
      const businessFunctionLableIds = Array.from(
        new Set(
          _.map(this.operateProps.extraDto.businessFunctionInfoDtos, (item) => {
            return _.split(item.extraProperties.lableIds, ',')
          }).flat()
        )
      )
      const functionLableIds = Array.from(
        new Set(_.concat(basicFunctionLableIds, businessFunctionLableIds))
      )
      this.showLabel = []
      // 回填除了功能带过来的之外的标签
      _.forEach(this.operateProps.extraDto.lableDtos, (item) => {
        if (
          !_.some(functionLableIds, (it) => {
            return it === item.id
          })
        ) {
          this.showLabel.push({
            key: item.id,
            label: item.name,
            disabled: this.operateType === 'read',
            // 如果是查看就都不能作删除操作
            canDelete: this.operateType !== 'read',
            isChecked: _.some(this.operateProps.extraDto.defaultLableIds, (i) => {
              return i === item.id
            }),
          })
        }
      })
      this.$set(this.formData, 'basicFunction', basicFunctionArr)
      this.$set(this.formData, 'businessFunction', businessFunctionArr)
      this.handlerTree(this.basicFunctionList, basicFunctionArr)
      this.handlerTree(this.businessFunctionList, businessFunctionArr)
    } else {
      // 如果是新增，默认是全部标签
      this.LabelList = _.cloneDeep(this.allLabel)
    }
  },
  methods: {
    changeCockpitConfig() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.activeConfig = 1
          this.selectLabelList = this.showLabel
          if (!_.isEmpty(this.operateProps)) {
            this.showCockpitLabels = []
            // 回填除了功能带过来的之外的标签
            _.forEach(this.operateProps.extraDto.cockpitLableDtos, (item) => {
              this.showCockpitLabels.push({
                key: item.id,
                label: item.name,
                disabled: this.operateType === 'read',
                // 如果是查看就都不能作删除操作
                canDelete: this.operateType !== 'read',
                isChecked: _.some(this.operateProps.extraDto.cockpitDefaultLableIds, (i) => {
                  return i === item.id
                }),
              })
            })
          }
        }
      })
    },
    // 关闭外部弹框的回调
    handleCloseOuter() {
      this.$emit('update:visible', false)
    },
    // 获取标签列表
    async getLabelList() {
      const [err, res] = await labelApi.getList({
        name: '',
        code: '',
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!err && res) {
        this.allLabel = _.map(res.items, (item) => {
          return {
            key: item.id,
            label: item.name,
          }
        })
      }
    },
    // 获取功能树形结构
    async getSubTreeList() {
      const [err, res] = await functionApi.getSubTrees()
      if (!err && res) {
        this.basicFunctionList = this.getTreeList(res, 1)
        this.businessFunctionList = this.getTreeList(res, 2)
      }
    },
    // 改变标签列表的内容
    changeShowLabel(newVal, oldVal) {
      const newArr = this.treeToArr(newVal)
      const oldArr = this.treeToArr(oldVal)
      // 所选功能增加，标签增加
      if (newArr.length > oldArr.length) {
        const labelIds = Array.from(
          new Set(
            _.map(newArr, (item) => {
              return _.split(item.labelIds, ',')
            }).flat()
          )
        )
        _.forEach(labelIds, (it) => {
          _.forEach(this.allLabel, (i) => {
            if (i.key === it) {
              // 如果标签列表中没有，则添加一条标签
              if (
                !_.some(this.showLabel, (val) => {
                  return val.key === it
                })
              ) {
                this.showLabel.unshift({
                  key: it,
                  label: i.label,
                  disabled: this.operateType === 'read',
                  canDelete: false,
                  isChecked:
                    this.computedNum <= 2 && !_.isEmpty(this.operateProps)
                      ? _.some(this.operateProps.extraDto.defaultLableIds, (item) => {
                          return item === it
                        })
                      : false,
                })
              } else {
                // 如果标签列表中有，则将屏蔽可删除操作
                _.forEach(this.showLabel, (val) => {
                  if (val.key === it && val.canDelete) {
                    val.canDelete = false
                  }
                })
              }
            }
          })
        })
      } else if (newArr.length < oldArr.length) {
        const newLabelIds = Array.from(
          new Set(
            _.map(newArr, (item) => {
              return _.split(item.labelIds, ',')
            }).flat()
          )
        )
        const oldLabelIds = Array.from(
          new Set(
            _.map(oldArr, (item) => {
              return _.split(item.labelIds, ',')
            }).flat()
          )
        )
        // 所选功能减少，得到标签差集
        const labelIds = _.filter(oldLabelIds, (item) => {
          return _.every(newLabelIds, (it) => {
            return item !== it
          })
        })
        _.forEach(labelIds, (item) => {
          this.showLabel = _.filter(this.showLabel, (it) => {
            return it.canDelete || it.key !== item
          })
        })
      }
    },
    // 根据已选择页面的权限 递归处理数据
    handlerTree(data, selectData) {
      const selData = _.cloneDeep(selectData)
      let flag = false
      for (let i = data.length - 1; i >= 0; i--) {
        for (let j = selData.length - 1; j >= 0; j--) {
          if (data[i] && data[i].id === selData[j].id) {
            // 当id相等可以删除的情况 即：没有子级可以删除；
            if (_.isEmpty(data[i].children)) {
              flag = true
              data.splice(i, 1)
            } else {
              const res = this.handlerTree(data[i].children, selData[j].children)
              res && i++
            }
          }
        }
      }
      return flag
    },
    // 树形化数组
    arrToTree(data, id) {
      const res = []
      _.forEach(data, (item) => {
        if (item.parentId === id) {
          res.push({
            pid: item.parentId,
            id: item.id,
            label: item.name,
            children: this.arrToTree(data, item.id),
            labelIds: item.extraProperties.lableIds,
            disabled: this.operateType === 'read',
          })
        }
      })
      return res
    },
    // 扁平化树形
    treeToArr(tree) {
      return tree.reduce((res, item) => {
        const { children, ...i } = item
        return res.concat(i, children && children.length ? this.treeToArr(children) : [])
      }, [])
    },
    // 获取树形穿梭框源数据
    getTreeList(data, type) {
      const res = []
      _.forEach(data, (item) => {
        if (item.detail.functionType === type) {
          const obj = {
            id: item.id,
            label: item.detail.name,
            pid: item.detail.parentId,
            labelIds: item.detail.extraProperties.lableIds,
            disabled: this.operateType === 'read',
          }
          if (!_.isEmpty(item.children)) {
            obj.children = this.getTreeList(item.children, type)
          } else {
            obj.children = []
          }
          res.push(obj)
        }
      })
      return res
    },
    // 保存新增编辑结果
    save() {
      if (!this.schemeId) {
        this.$message.warning('请选择方案')
        return
      }
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          let err = null
          let res = {}
          if (_.isEmpty(this.operateProps)) {
            // 新增
            ;[err, res] = await sectionApi.create({
              body: {
                schemeId: this.schemeId || null,
                name: this.formData.name,
                sceneId: this.formData.sceneId || null,
                cockpitId: this.formData.cockpitId || null,
                cockpitSceneId: this.formData.cockpitSceneId || null,
                functionLocationType: this.formData.functionLocationType,
                extraProperties: {
                  lableIds: _.join(
                    _.map(this.showLabel, (item) => {
                      return item.key
                    }),
                    ','
                  ),
                  defaultLableIds: _.join(
                    _.map(
                      _.filter(this.showLabel, (item) => {
                        return item.isChecked
                      }),
                      (it) => {
                        return it.key
                      }
                    ),
                    ','
                  ),
                  cockpitLableIds: _.join(
                    _.map(this.showCockpitLabels, (item) => {
                      return item.key
                    }),
                    ','
                  ),
                  cockpitDefaultLableIds: _.join(
                    _.map(
                      _.filter(this.showCockpitLabels, (item) => {
                        return item.isChecked
                      }),
                      (it) => {
                        return it.key
                      }
                    ),
                    ','
                  ),
                  functionInfoIds: _.join(
                    _.map(this.treeToArr(this.functionAll), (item) => {
                      return item.id
                    }),
                    ','
                  ),
                },
              },
            })
          } else {
            // 编辑
            ;[err, res] = await sectionApi.update(this.operateProps.id, {
              body: {
                schemeId: this.schemeId || null,
                id: this.operateProps.id,
                name: this.formData.name,
                cockpitId: this.formData.cockpitId || null,
                cockpitSceneId: this.formData.cockpitSceneId || null,
                sceneId: this.formData.sceneId || null,
                functionLocationType: this.formData.functionLocationType,
                extraProperties: {
                  lableIds: _.join(
                    _.map(this.showLabel, (item) => {
                      return item.key
                    }),
                    ','
                  ),
                  defaultLableIds: _.join(
                    _.map(
                      _.filter(this.showLabel, (item) => {
                        return item.isChecked
                      }),
                      (it) => {
                        return it.key
                      }
                    ),
                    ','
                  ),
                  cockpitLableIds: _.join(
                    _.map(this.showCockpitLabels, (item) => {
                      return item.key
                    }),
                    ','
                  ),
                  cockpitDefaultLableIds: _.join(
                    _.map(
                      _.filter(this.showCockpitLabels, (item) => {
                        return item.isChecked
                      }),
                      (it) => {
                        return it.key
                      }
                    ),
                    ','
                  ),
                  functionInfoIds: _.join(
                    _.map(this.treeToArr(this.functionAll), (item) => {
                      return item.id
                    }),
                    ','
                  ),
                },
              },
            })
          }
          if (!err && res) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.$emit('update:visible', false)
            this.$emit('refresh')
          }
          this.saveLoading = false
        }
      })
    },
    // 打开嵌套弹框的回调
    handleOpenInner() {
      // 将选择的标签置空
      this.chooseLabelList = []
      this.chooseCockpitLabelList = []
    },
    // 点击删除标签
    deleteLabel(index) {
      this.showLabel.splice(index, 1)
    },
    // 点击删除标签
    deleteCockpitLabel(index) {
      this.showCockpitLabels.splice(index, 1)
    },
    // 保存标签选择
    saveLabel() {
      if (this.activeConfig === 0) {
        this.showLabel.push(
          ..._.map(this.chooseLabelList, (item) => {
            const obj = { isChecked: false, canDelete: true }
            _.forEach(this.LabelList, (i) => {
              if (i.key === item) {
                obj.key = i.key
                obj.label = i.label
              }
            })
            return obj
          })
        )
      } else {
        this.showCockpitLabels.push(
          ..._.map(this.chooseCockpitLabelList, (item) => {
            const obj = { isChecked: false, canDelete: true }
            _.forEach(this.selectLabelList, (i) => {
              if (i.key === item) {
                obj.key = i.key
                obj.label = i.label
              }
            })
            return obj
          })
        )
      }
      this.labelVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.large-dialog {
  ::v-deep .el-dialog {
    .wl-transfer,
    .el-input,
    .el-select,
    .el-input-number {
      width: 100%;
      max-width: 440px;
      line-height: 36px;
    }

    .transfer {
      .transfer-left,
      .transfer-right {
        width: 180px;
      }

      .transfer-center {
        display: flex;
        width: 80px;
        flex-direction: row-reverse;

        .transfer-center-item {
          padding: 8px;
        }
      }

      .el-button {
        padding: 0 2px;
        width: 20px;
        height: 28px;
        border: 1px solid rgb(220, 222, 226);
        border-radius: 4px;
        line-height: 1;

        i {
          color: rgb(229, 231, 235);
        }

        &.is-disabled {
          background-color: rgb(242, 246, 252);

          i {
            color: rgb(48, 49, 51);
          }
        }
      }
    }

    .label-ui {
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #dcdfe6;
        border-radius: 6px;
      }
    }
  }
}

::v-deep .el-dialog.label-dialog {
  .el-transfer-panel {
    width: 180px;
  }

  .el-transfer__buttons {
    padding: 0 15px;

    .el-transfer__button + .el-transfer__button {
      margin-left: 0;
    }
  }

  .el-transfer-panel__filter {
    width: auto;
  }
}

.config-tab {
  .vis-tab {
    border: 1px solid #409eff;
    border-radius: 5px 0 0 5px;
  }

  .cockpit-tab {
    border-radius: 0 5px 5px 0;
    border-top: 1px solid #409eff;
    border-right: 1px solid #409eff;
    border-bottom: 1px solid #409eff;
  }
}

.tab-select {
  color: #fff !important;
  background-color: #409eff !important;
}
</style>
